module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.routes), function(item) {
    return [(!item.hidden && item.noDropdown && item.children.length > 0) ? _c('router-link', {
      attrs: {
        "to": item.path === '/' ? item.path + item.children[0].path : item.path + '/' + item.children[0].path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": item.path === '/' ? item.path + item.children[0].path : item.path + '/' + item.children[0].path
      }
    }, [(item.icon) ? _c('i', {
      class: item.icon
    }) : _vm._e(), _c('span', {
      staticClass: "sidebar-item-name"
    }, [_vm._v(_vm._s(item.children[0].name))])])], 1) : _vm._e(), _vm._v(" "), (!item.noDropdown &&
      !item.hidden) ? _c('el-submenu', {
      attrs: {
        "index": item.name
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.icon) ? _c('i', {
      class: item.icon
    }) : _vm._e(), _c('span', {
      staticClass: "sidebar-item-name"
    }, [_vm._v(_vm._s(item.name) + "  ")])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? [(!child.children) ? _c('router-link', {
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(child.name) + "\n\t\t\t\t\t")])], 1) : _vm._e()] : _vm._e()
    })], 2) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b25649f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/SidebarItem.vue
// module id = 763
// module chunks = 2